import { resolve } from '@/core/di';
import { AnonymizationDataToken } from '../di/token';
import type { AnonymizationDataRepository } from '../domain/repositories/AnonymizationDataRepository';

export { default as AnonymizationSwitch } from '../ui/AnonymizationSwitch.vue';

export const anonymizationData: () => AnonymizationDataRepository = () =>
  resolve(AnonymizationDataToken);
